import React, { JSX } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import Header from './components/layout/Header';
import FooterNew from './components/layout/FooterNew';
import ScrollToTop from './components/ScrollToTop';
import { AuthContextType } from './types/context.d';

function AppShell(): JSX.Element {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith('/user') || pathname.startsWith('/company') || pathname.startsWith('/agent') || pathname.startsWith('/admin');

  return (
    <div className="min-h-screen flex flex-col bg-white transition-colors duration-300">
      <ScrollToTop />
      {!isDashboard && <Header />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isDashboard && <FooterNew />}
    </div>
  );
}

function App(): JSX.Element {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
